/** Reine Hilfen für die Paket-15-Oberfläche. */

export function baueKalenderFeedAdresse(
  token: string,
  apiAdresse: string,
  seitenUrsprung: string,
): string {
  const adresse = new URL(apiAdresse, seitenUrsprung);
  const apiPfad = adresse.pathname.replace(/\/trpc\/?$/, "");
  adresse.pathname = `${apiPfad}/kalender/${encodeURIComponent(token)}.ics`
    .replace(/\/{2,}/g, "/");
  adresse.search = "";
  adresse.hash = "";
  return adresse.toString();
}

export function minutenAusEingabe(wert: string): number | null {
  if (!/^\d+$/.test(wert.trim())) return null;
  const minuten = Number(wert);
  return Number.isSafeInteger(minuten) && minuten >= 0 && minuten <= 24 * 60
    ? minuten
    : null;
}
